<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <div class="sayfahead">
      <h1>{{ Damga }} {{ Sayfa.Adi }}</h1>
      <el-button-group v-if="tableDisplay" class="float-right">
        <a @click="Yazdir" class="el-button YeniBtn el-button--primary el-button--small"
        ><i class="feather-printer"></i> Yazdır
        </a>
      </el-button-group>
    </div>
    <div class="icerik" style="height: calc(100vh - 120px);">
      <div class="raporbloksabitle">
        <el-row :gutter="24">
          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">
            <el-col :span="5">
              <el-form-item label="Site / Bina" prop="Bina_id">
                <el-select v-model="Form.Bina_id" filterable>
                  <el-option-group
                    label="Site Listesi">
                    <el-option
                      v-for="item in Siteler"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                  <el-option-group
                    label="Bina Listesi">
                    <el-option
                      v-for="item in Binalar"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Rapor Ay" prop="Tarih">
                <el-select v-model="Form.Tarih" filterable>
                  <el-option
                    v-for="item in Aylar"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="12">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </el-row>
        <div v-if="tableDisplay">
          <h5 class="text-center">{{ TextBinaAdi }}</h5>
          <h6 class="text-center">{{ TextTarih }} Ayı Gelir Gider Dökümü</h6>
          <table class="table table-xs table-siyah mb-0" style="border-bottom: 0 !important;">
            <thead>
            <tr>
              <th class="text-center">GELİR</th>
            </tr>
            </thead>
          </table>
          <table class="table table-xs table-bilanco table-siyah">
            <thead>
            <tr>
              <th>Gelir Türü</th>
              <th class="text-right">Tahakkuk</th>
              <th class="text-right">Zam Geliri</th>
              <th class="text-right">Tahsil</th>
            </tr>
            </thead>
            <tbody v-for="g in tableData.Gelir">
            <tr>
              <td>{{ g.Adi }}</td>
              <td class="text-right">{{ g.Tahakkuk }}</td>
              <td class="text-right">{{ g.Zam }}</td>
              <td class="text-right">{{ g.Tutar }}</td>
            </tr>
            <tr class="tr-xs" v-for="ga in g.children">
              <td>{{ ga.Adi }}</td>
              <td class="text-right">{{ ga.Tahakkuk }}</td>
              <td class="text-right">{{ ga.Zam }}</td>
              <td class="text-right">{{ ga.Tutar }}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th class="text-right">ALT TOPLAM</th>
              <th class="text-right">{{ tableData.AltToplam.Tahakkuk }}</th>
              <th class="text-right">{{ tableData.AltToplam.Zam }}</th>
              <th class="text-right">{{ tableData.AltToplam.Gelir }}</th>
            </tr>
            </tfoot>
          </table>
          <hr>
          <table class="table table-xs table-siyah mb-0" style="border-bottom: 0 !important;">
            <thead>
            <tr>
              <th class="text-center">GİDER</th>
            </tr>
            </thead>
          </table>
          <table class="table table-xs table-bilanco table-siyah">
            <thead>
            <tr>
              <th>Tarih</th>
              <th>Gider Türü</th>
              <th>Açıklama</th>
              <th class="text-right">Tutar</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="gd in tableData.Gider">
              <td>{{ gd.Tarih }}</td>
              <td>{{ gd.Kategori }}</td>
              <td>{{ gd.Aciklama }}</td>
              <td class="text-right">{{ gd.Tutar }}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3" class="text-right">ALT TOPLAM</th>
              <th class="text-right">{{ tableData.AltToplam.Gider }}</th>
            </tr>
            </tfoot>
          </table>
          <hr>
          <el-row :gutter="24">
            <el-col :span="6">
              <table class="table table-xs table-sari">
                <thead>
                <tr>
                  <th>KASA BLOKE</th>
                  <th class="text-right">{{ tableData.AltToplam.Bloke }}</th>
                </tr>
                </thead>
              </table>
            </el-col>
            <el-col :span="6">
              <table class="table table-xs table-mavi">
                <thead>
                <tr>
                  <th>TAZMİNAT FONU</th>
                  <th class="text-right">{{ tableData.AltToplam.Kidem }}</th>
                </tr>
                </thead>
              </table>
            </el-col>
            <el-col :span="12">
              <table class="table table-xs table-yesil" :class="Form.Kasa==true?'mb-0':''">
                <thead>
                <tr>
                  <th>KULLANILABİLİR KASA BAKİYESİ</th>
                  <th class="text-right">{{ tableData.AltToplam.Para }}</th>
                </tr>
                </thead>
              </table>
              <el-table
                class="alttable table-xs mt-0 mb-3 table-yesil"
                style="border-top: 0 !important;width: 100%"
                width="100%"
                v-if="Form.Kasa"
                :data="kasaData"
                row-key="id"
                height="200px"
                default-expand-all>
                <el-table-column
                  prop="Adi"
                  label="Kasa Adı">
                </el-table-column>
                <el-table-column
                  prop="Bakiye"
                  label="Bakiye"
                  align="right"
                  width="120">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      Binalar: [],
      Siteler: [],
      Aylar: [],
      KasaHeight: '200px',
      lo: false,
      Yetki: false,
      Kaydet: false,
      Sayfa: {
        Adi: 'Aylık Bilanço',
        ButtonAdi: 'Uygula',
        FiltreAdi: 'Filtreleme',
      },
      FormHata: {
        Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      Form: {
        Bina_id: null,
        Tarih: [],
      },
      AltToplam: {
        Gelir: 0,
        Gider: 0,
        Bloke: 0,
        Kidem: 0,
        Para: 0,
        Tahakkuk: 0
      },
      tableData: null,
      kasaData: null,
      ExcelData: null,
      tableDisplay: false,
      TextBinaAdi: '',
      TextTarih: '',
    }
  },
  methods: {
    GelirFooter() {
      const sums = [];
      sums[1] = this.AltToplam.Tahakkuk;
      sums[2] = this.AltToplam.Gelir;
      return sums;
    },
    GiderFooter() {
      const sums = [];
      sums[3] = this.AltToplam.Gider;
      return sums;
    },
    Getir() {

      this.$refs['RaporForm'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Post", {...this.Form, path: 'raporlama/kasa/aylik'})
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.tableData = response.tableData;
                this.AltToplam = response.tableData.AltToplam;
                this.ExcelData = response.ExcelData;
                this.kasaData = response.kasaData;
                this.Damga = response.Damga;
                if (this.tableData) this.tableDisplay = true;
                this.TextBinaAdi = response.Bilgi.BinaAdi;
                this.TextTarih = response.Bilgi.Tarih;


              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }
      })

    },

    Yazdir() {
      window.print()
    },
    SayfaYukle() {
      this.$store.dispatch("Get", {path: 'spesiyal/diger'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Aylar = response.Data
          }
        });
      this.$store.dispatch("Get", {path: 'muhasebe/list/bina'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Binalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.$store.dispatch("Get", {path: 'muhasebe/list/site'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Siteler = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    }
  },
  created() {
    this.SayfaYukle();
    this.Yetki = this.$store.getters.Yetki.raporlama == 2 ? true : false;
    if (this.$store.getters.BinaBilgi) {
      this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Raporlama/kasa/aylik.vue